/* Global add-to-cart for product pages */
window.lsAddToCart = function(variantId, productTitle) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({items: [{id: parseInt(variantId), quantity: 1}]})
  }).then(function(r) { return r.json(); }).then(function() {
    var count = document.getElementById("ls-cart-count");
    if (count) {
      fetch("/cart.js").then(function(r) { return r.json(); }).then(function(c) { count.textContent = c.item_count; });
    }
    window.location.href = "/cart";
  }).catch(function(err) {
    console.error("Add to cart error:", err);
  });
};

(function(){
"use strict";

/* ---- Add to cart (product cards) ---- */
document.querySelectorAll(".ls-add-to-cart").forEach(function(btn){
  btn.addEventListener("click",function(){
    var vid=btn.getAttribute("data-variant-id");
    if(!vid)return;
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:parseInt(vid),quantity:1}]})}).then(function(r){return r.json();}).then(function(){
      var count=document.getElementById("ls-cart-count");
      if(count){fetch("/cart.js").then(function(r){return r.json();}).then(function(c){count.textContent=c.item_count;});}
      window.location.href="/cart";
    });
  });
});

/* ---- PROMO BUNDLE ---- */
var promoBtn=document.getElementById("ls-promo-add");
if(promoBtn){
  promoBtn.addEventListener("click",function(){
    promoBtn.textContent="Ajout en cours...";
    promoBtn.disabled=true;
    fetch("/cart/add.js",{
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({items:[
        {id:53669787238741,quantity:1},
        {id:53669787205973,quantity:1},
        {id:53669787173205,quantity:1}
      ]})
    }).then(function(r){return r.json();}).then(function(){
      window.location.href="/cart";
    }).catch(function(){
      promoBtn.textContent="Profiter de l'offre \u2192";
      promoBtn.disabled=false;
    });
  });
}

/* ---- Remove from cart (delegated) ---- */
document.addEventListener("click",function(e){
  var btn=e.target.closest(".ls-remove-btn");
  if(!btn)return;
  var key=btn.getAttribute("data-key");
  if(!key)return;
  fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:key,quantity:0})}).then(function(){location.reload();});
});

})();